import { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import ScoreRanking from "components/pages/ScoreRanking";

interface Props {
  isMobile: boolean;
  initialList?: any[] | null;
  initialLoc?: string;
}

const ScoreRankingPage: NextPage<Props> = ({
  isMobile,
  initialList,
  initialLoc,
}) => {
  return (
    <ScoreRanking
      isMobile={isMobile}
      initialList={initialList}
      initialLoc={initialLoc}
    />
  );
};

export default ScoreRankingPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";
  const loc = typeof context.query.loc === "string" ? context.query.loc : "";
  const base = process.env.NEXTAUTH_URL;

  let initialList: any[] | null = null;
  try {
    const res = await fetch(
      `${base}/api/hightotalscore?limit=100&loc=${encodeURIComponent(loc)}`
    );
    if (res.ok) initialList = await res.json();
  } catch {
    initialList = null;
  }

  return {
    props: {
      initialList,
      initialLoc: loc,
      ...(await serverSideTranslations(locale, ["main"])),
    },
  };
}
